<avi-dashboard-widget
    class="proxy-widget"
    shape="cloud-proxy"
    status="success"
    [iconSize]="24"
    headerText="{{ l10nKeys.proxyHeader | vtranslate }}"
>
    <div
        dashboardWidgetBody
        class="proxy-widget__body"
        *ngrxLet="useSplitProxyStatus$ as useSplitProxyStatus"
    >
        <span class="proxy-widget__label">
            {{ l10nKeys.cloudServiceSplitProxyLabel | vtranslate }}
        </span>
        <div
            class="proxy-widget__value sel-portal-url"
            [ngClass]="useSplitProxyStatus ? 'proxy-widget__enabled' : 'proxy-widget__deactivated'"
        >
            {{ (useSplitProxyStatus ? l10nKeys.enabledLabel : l10nKeys.deactivatedLabel) | vtranslate }}
        </div>
    </div>
</avi-dashboard-widget>
